import { useCallback, useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import { cacheCreds } from '../lib/hermesChats';

// Central AgentBro agent (plan 216). Daytona/sandbox is phased out — there is no
// broker call, no wake, no token refresh. The chat talks to the Django proxy at
// /api/agentbro/*, authenticated with the app JWT (localStorage `token`). This hook
// just packages that so HermesChat's props stay unchanged.
const AGENT_BASE = `${API_BASE_URL}/api/agentbro`;

export default function useHermesSession() {
  const [state, setState] = useState({
    baseUrl: AGENT_BASE,
    sessionToken: localStorage.getItem('token') || null,  // JWT — used as Bearer
    sessionKey: localStorage.getItem('userId') || 'me',
    wakeMs: null,
    expiresAt: 0,
    chart: null,
    filesBase: API_BASE_URL,
    loading: false,
    error: null,
  });

  const refresh = useCallback(() => {
    const token = localStorage.getItem('token') || null;
    // Let the global sidebar list/delete/rename threads without its own call.
    cacheCreds(AGENT_BASE, token, 0);
    setState((s) => ({ ...s, baseUrl: AGENT_BASE, sessionToken: token,
      filesBase: API_BASE_URL, loading: false, error: null }));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
}
